<ng-container>
    @if (selectedItem.iconClass) {
        <i [class]="selectedItem.iconClass" aria-hidden="true"></i>
    }
    @if (!selectedItem.iconClass) {
        <img [attr.src]="selectedItem.imageSrc | asset" [ngClass]="selectedItem.imageClass ?? ''"
             alt="{{ selectedItem.altText }}"/>
    }
    <h3 [innerHTML]="selectedItem.headerText | safeHtml: 'html' "></h3>
</ng-container>
